<template>
  <div class="a4">
    <nav-header></nav-header>
    <div class="info">
      <p>快乐运动100——一站式移动骑行服务平台</p>
      <p>汇聚了全国数百万的骑行爱好者。解决骑友怎么骑行、跟谁骑行以及去哪骑行的难题，为骑友提供不断完善的骑行服务体验；</p>

      <p>1、发现赛事活动</p>

      <img src="/imgs/nf/1.jpg" alt="">

      <p>2、专注你的骑行运动</p>

      <img src="/imgs/nf/2.jpg" alt="">

      <p>3、融入你的运动圈</p>

      <img src="/imgs/nf/3.jpg" alt="">

      <p>4、一目了然的个人数据</p>
      <img src="/imgs/nf/4.jpg" alt="">
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
// import ac2 from "./../components/ac2";
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";

export default {
  name: "a4",
  data() {
    return {
      msrc: "/mock/info.json",
      mtitle: "行业资讯",
    };
  },
  components: {
    // ac2,

    NavFooter,
    NavHeader,
  },
  methods: {
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { id: id },
      });
    },
    // 收费逻辑
    gopay() {
      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
      }
      // 未登录
      if (this.state !== 0) {
        alert("请注册购买~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
  },
  mounted() {
    document.title = "快乐韵动（北京）体育有限公司";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.a4 {
  width: 100%;
  margin-top: 100px;
  position: relative;

  .info {
    width: 1200px;
    margin: 20px auto;
    // background-color: #f1f1f1;
    text-align: center;
    line-height: 31px;
    p {
      font-size: 16px;
      color: #888;
      margin: 15px 0;
      text-align: left;
    }
  }

}
</style>
